import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export const gltfCache = new Map();

export function loadGLTF(url) {
  if (gltfCache.has(url)) return Promise.resolve(gltfCache.get(url));
  return new Promise((resolve, reject) => {
    new GLTFLoader().load(url, gltf => { gltfCache.set(url, gltf); resolve(gltf); }, undefined, reject);
  });
}
